import { useState } from 'react';
import ReactDOM from 'react-dom';
import Layout from 'layout';
import { ReactComponent as GlobalIcon } from 'img/select/global.svg';
import i18n from 'local/i18n';
import './index.css';

const LanguageSelect = props => {
  const { options = [], value, onSelect } = props;
  const [selectedValue, setSelectedValue] = useState(value);

  // 多語系實作
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang)
  }

  const handleChange = event => {

    const val = event.target.value;
    changeLanguage(val);
    setSelectedValue(val);
    onSelect?.(val);

    // 抓取當下語系 在layout div 加入控制項
    ReactDOM.render(
      <Layout classNames={val} />,
    document.getElementById('root')
    );

  };


  return (
    <div className="lanSelectWrapper">
      <GlobalIcon />
      <select className="lanSelect" value={selectedValue} onChange={handleChange}>
        {options.map(({ text, value: val }) => {
          const value = val ?? text;
          return (
            <option key={value} value={value}>
              {text}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default LanguageSelect;
